'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var MenuItemGroup = _react2["default"].createClass({
  displayName: 'MenuItemGroup',

  propTypes: {
    renderMenuItem: _react.PropTypes.func,
    index: _react.PropTypes.number
  },

  getDefaultProps: function getDefaultProps() {
    return {
      disabled: true
    };
  },
  renderInnerMenuItem: function renderInnerMenuItem(item, subIndex) {
    var renderMenuItem = this.props.renderMenuItem;
    return renderMenuItem(item, this.props.index, subIndex);
  },
  render: function render() {
    var props = this.props;
    var className = props.className || '';
    var rootPrefixCls = props.rootPrefixCls;

    className += ' ' + rootPrefixCls + '-item-group';
    var titleClassName = rootPrefixCls + '-item-group-title';
    var listClassName = rootPrefixCls + '-item-group-list';
    return _react2["default"].createElement(
      'li',
      { className: className },
      _react2["default"].createElement(
        'div',
        { className: titleClassName },
        props.title
      ),
      _react2["default"].createElement(
        'ul',
        { className: listClassName },
        _react2["default"].Children.map(props.children, this.renderInnerMenuItem)
      )
    );
  }
});

MenuItemGroup.isMenuItemGroup = true;

exports["default"] = MenuItemGroup;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-menu/lib/MenuItemGroup.js
 ** module id = 1111
 ** module chunks = 0
 **/